import { render, staticRenderFns } from "./LoginWindow.vue?vue&type=template&id=644f963c"
import script from "./LoginWindow.vue?vue&type=script&lang=js"
export * from "./LoginWindow.vue?vue&type=script&lang=js"
import style0 from "./LoginWindow.vue?vue&type=style&index=0&id=644f963c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports